"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Back to previous panel": "Retour au panneau précédent",
  "Close Panel": "Fermer le panneau",
  "Close {title}": ["Fermer ", ["title"]],
  "More options": "Plus d’options",
  "Panel menu": "Menu du panneau"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map